import React, {useEffect, useState} from "react";
import {BsArrowLeftCircleFill, BsArrowRightCircleFill} from "react-icons/bs";
import imageNotFound from './img.png';
import "./Carousel.css";
import HttpService from "../../Portal/Services/HttpService";

function Carousel({data}) {
    const [slide, setSlide] = useState(0);

    const nextSlide = () => {
        setSlide(slide === data.length - 1 ? 0 : slide + 1);
    };

    const prevSlide = () => {
        setSlide(slide === 0 ? data.length - 1 : slide - 1);
    };


    function MyImage({ item, idx, slide }) {
        const [imageUrl, setImageUrl] = useState(null);

        useEffect(() => {
            fetch(`${HttpService.API_SERVER}Media/DownloadFile?path=${encodeURIComponent(item)}`)
                .then(res => {
                    if (!res.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return res.text();
                })
                .then(text => {
                    setImageUrl(text);
                })
                .catch(err => {
                    console.error("Image fetch error:", err);
                });
        }, [item]);


        if (!imageUrl) return null;

        return (
            <img
                src={imageUrl}
                alt={idx}
                key={idx}
                className={slide === idx ? "slide" : "slide slide-hidden"}
            />
        );
    }



    return (
        <div className="carousel">
            {data.length === 0 ?
                <img src={imageNotFound} alt='not image' className={"slide"}/>
                :
                <div>
                    <BsArrowLeftCircleFill onClick={prevSlide} className="arrow arrow-left"/>
                    {data.map((item, idx) => {
                        return (
                            <MyImage item={item} idx={idx} slide={slide}/>
                        );
                    })}
                    <BsArrowRightCircleFill
                        onClick={nextSlide}
                        className="arrow arrow-right"
                    />
                    <span className="indicators">
                        {data.map((_, idx) => {
                            return (
                                <button
                                    key={idx}
                                    className={
                                        slide === idx ? "indicator" : "indicator indicator-inactive"
                                    }
                                    onClick={() => setSlide(idx)}
                                ></button>
                            );
                        })}
                    </span>
                </div>
            }

        </div>
    );
}

export default Carousel;